import type { JourneyStageDef } from '../model/content'
import styles from './StageSelfCheck.module.css'

export default function StageSelfCheck({ stage, disabled }: { stage: JourneyStageDef; disabled: boolean }) {
  return <fieldset className={styles.selfCheck} disabled={disabled}>
    <legend>Эта стадия про меня?</legend>
    <p>{stage.user_text}</p>
    <p>Это самопроверка, а не экзамен. Отметьте то, что про вас. Остаться на этой стадии или перейти — решаете вы.</p>
    {stage.checklist.map(text => <label key={text}>
      <input type="checkbox" />
      <span>{text}</span>
    </label>)}
  </fieldset>
}
